import React from 'react';
import { useSelector } from 'react-redux';
import './SportCheckOverview.scss';
import OverviewCard from '../dashboard/OverviewCard';
import NoOfRecalledTransactionsCard from './NoOfRecalledTransactionsCard';


const AUTO_APPROVED_TRANSACTION_CARD_CONFIG = [
  {
    type: 'large',
    title: 'Percentage of auto approved transactions out of all phtoto taking & barcode transaction',
    key: 'percentageOfAutoApprovedTransactions',
    showPercentageSyntax: true,
  },
  {
    type: 'multiple',
    title: 'Total auto approved transactions',
    key: 'totalNumberOfAutoApprovedTransactions',
    title2: 'All transactions (barcode&photo taking)',
    key2: 'totalNumberOfTransactions',
  },
  {
    type: 'multiple',
    title: 'Approved by earning rule',
    key: 'totalNumberOfApprovedByEarningRuleTransactions',
    title2: 'Approved by AI',
    key2: 'totalNumberOfApprovedByAiTransactions',
  }
];

const SPOT_CHECKED_TRANSACTION_CARD_CONFIG = [
  {
    type: 'large',
    title: 'Total number of spot-checked tansactions',
    key: 'totalNumberOfSpotCheckedTransactions',
  }
];

const SPOT_CHECKED_DATA_CARD_CONFIG = [
  {
    type: 'large',
    title: 'Passed',
    key: 'totalNumberOfSpotCheckedPassedTransactions',
  },
  {
    type: 'large',
    title: 'Recalled',
    key: 'totalNumberOfSpotCheckedRecalledTransactions',
  },
];
const SpotCheckOverview = () => {
  const spotCheckRecordsOverviewData = useSelector((state) => state.overview.spotCheckRecords);
  return (
    <div>
      <div className="overview-row-title overview-campaigns-title">
        AUTO APPROVED TRANSACTIONS
      </div>
      <div className="overview-row customer-overview-row">
        {AUTO_APPROVED_TRANSACTION_CARD_CONFIG.map((config) => {
          return (
            <OverviewCard
              title={config.title}
              type={config.type}
              value2={spotCheckRecordsOverviewData[config.key2]?.value}
              change2={spotCheckRecordsOverviewData[config.key2]?.change}
              title2={config.title2}
              value={spotCheckRecordsOverviewData[config.key]?.value}
              change={spotCheckRecordsOverviewData[config.key]?.change}
              showPercentageSyntax={config.showPercentageSyntax}
            />
          );
        })}
      </div>
      <div className="overview-row-title overview-campaigns-title">
        SPOT-CHECKED TRANSACTIONS
      </div>
      <div className="overview-row customer-overview-row">
        {SPOT_CHECKED_TRANSACTION_CARD_CONFIG.map((config) => {
          return (
            <OverviewCard
              title={config.title}
              type={config.type}
              value2={spotCheckRecordsOverviewData[config.key2]?.value}
              change2={spotCheckRecordsOverviewData[config.key2]?.change}
              title2={config.title2}
              value={spotCheckRecordsOverviewData[config.key]?.value}
              change={spotCheckRecordsOverviewData[config.key]?.change}
            />
          );
        })}
      </div>
      <div className="overview-row-title overview-campaigns-title">
        SPOT-CHECKED DATA
      </div>
      <div className="overview-row customer-overview-row">
        {SPOT_CHECKED_DATA_CARD_CONFIG.map((config) => {
          return (
            <OverviewCard
              title={config.title}
              type={config.type}
              value2={spotCheckRecordsOverviewData[config.key2]?.value}
              change2={spotCheckRecordsOverviewData[config.key2]?.change}
              title2={config.title2}
              value={spotCheckRecordsOverviewData[config.key]?.value}
              change={spotCheckRecordsOverviewData[config.key]?.change}
              isSpotCheck={true}
            />
          );
        })}
      </div>
      <NoOfRecalledTransactionsCard />
    </div>
  );
};
export default SpotCheckOverview;
